// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f714809","453":"03b07586","455":"5865b2bf","977":"1878e56b"}[chunkId] + ".chunk.js";
};